var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSiren(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 19H4V21H20V19ZM4 17C2.89543 17 2 17.8954 2 19V23H22V19C22 17.8954 21.1046 17 20 17H4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 17V11C17 8.23858 14.7614 6 12 6C9.23858 6 7 8.23858 7 11L7 17H17ZM12 4C8.13401 4 5 7.13401 5 11V17C5 18.1046 5.89543 19 7 19H17C18.1046 19 19 18.1046 19 17V11C19 7.13401 15.866 4 12 4Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 11C20 10.4477 20.4477 10 21 10H22C22.5523 10 23 10.4477 23 11C23 11.5523 22.5523 12 22 12H21C20.4477 12 20 11.5523 20 11Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11C4 10.4477 3.55228 10 3 10H2C1.44772 10 1 10.4477 1 11C1 11.5523 1.44772 12 2 12H3C3.55228 12 4 11.5523 4 11Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1063 2.89287C19.4968 3.28339 19.4968 3.91656 19.1063 4.30708L18.4063 5.00708C18.0158 5.39761 17.3826 5.39761 16.9921 5.00708C16.6016 4.61656 16.6016 3.98339 16.9921 3.59287L17.6921 2.89287C18.0826 2.50234 18.7158 2.50234 19.1063 2.89287Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7073 4.65433e-05C12.2595 4.66276e-05 12.7073 0.447762 12.7073 1.00005V2.41426C12.7073 2.96654 12.2595 3.41426 11.7073 3.41426C11.155 3.41426 10.7073 2.96654 10.7073 2.41426L10.7073 1.00005C10.7073 0.447762 11.155 4.64169e-05 11.7073 4.65433e-05Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.89368 2.89287C4.50315 3.28339 4.50315 3.91656 4.89367 4.30708L5.59367 5.00708C5.9842 5.39761 6.61736 5.39761 7.00789 5.00708C7.39841 4.61656 7.39841 3.98339 7.00789 3.59287L6.30789 2.89287C5.91737 2.50234 5.2842 2.50234 4.89368 2.89287Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 8C13 8.55228 12.5523 9 12 9C11.1641 9 10.7069 9.35802 10.4222 9.76921C10.1009 10.2333 10 10.7794 10 11C10 11.5523 9.55228 12 9 12C8.44772 12 8 11.5523 8 11C8 10.4206 8.19909 9.46672 8.77781 8.63079C9.39313 7.74198 10.4359 7 12 7C12.5523 7 13 7.44772 13 8Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiren);
export default __webpack_public_path__ + "static/media/siren.8777c2d21afd1ef99175eb6423b9482a.svg";
export { ForwardRef as ReactComponent };